module.exports = __webpack_public_path__ + "assets/img/circle.6cf91b6a.png";